import Swiper from 'swiper/js/swiper';

jQuery(function() {

  if ($('.category-slider-container').length > 0) {
    let spaceBetween = 20,
      slidesOffsetAfter = 20;
    if (window.innerWidth > 992) { //$screen-lg-min
      spaceBetween = 50;
      slidesOffsetAfter = 50;
    }
    new Swiper('.category-slider-container', {
      slidesPerView: 'auto',
      loop: false,
      spaceBetween: spaceBetween,
      effect: 'slide',
      slidesOffsetAfter: slidesOffsetAfter,
      freeMode: true,
      freeModeSticky: true,
      navigation: {
        nextEl: '.category-slider-button-next',
        prevEl: '.category-slider-button-prev',
      },
    });
  }
});
